export default __webpack_public_path__ + "static/media/LoginBg.2c39f5ea.png";